import React from "react"
import FieldProto_FormElement from "../../../../proto/render/form-element";
import FieldDropdownLazyLoading_FormView from "./form-view";
import FieldDropdownLazyLoading from "../../dropdown-lazy-loading";

export default class FieldDropdownLazyLoading_FormElement extends FieldProto_FormElement {

    render() {
        return <FieldDropdownLazyLoading_FormView className      = {this.props.className}
                                 field          = {this.props.field as unknown as FieldDropdownLazyLoading}
                                 value          = {this.value}
                                 model          = {this.props.model}
                                 configOptions  = {this.props.options}
                                 disabled       = {this.props.disabled}
                                 onChange       = {this.onChange}/>
    }

}